import { render, staticRenderFns } from "./BKES.vue?vue&type=template&id=02304300&"
import script from "./BKES.vue?vue&type=script&lang=js&"
export * from "./BKES.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports